
/**
 * 省份简称列表，带首字母排序
 */
const provinceLetters = [{
    text: '川',
    letter: 'C',
    province: '四川省'
}, {
    text: '鄂',
    letter: 'E',
    province: '湖北省'
}, {
    text: '赣',
    letter: 'G',
    province: '江西省'
}, {
    text: '桂',
    letter: 'G',
    province: '广西壮族自治区'
}, {
    text: '甘',
    letter: 'G',
    province: '甘肃省'
}, {
    text: '贵',
    letter: 'G',
    province: '贵州省'
}, {
    text: '黑',
    letter: 'H',
    province: '黑龙江省'
}, {
    text: '沪',
    letter: 'H',
    province: '上海市'
}, {
    text: '京',
    letter: 'J',
    province: '北京市'
}, {
    text: '津',
    letter: 'J',
    province: '天津市'
}, {
    text: '晋',
    letter: 'J',
    province: '山西省'
}, {
    text: '吉',
    letter: 'J',
    province: '吉林省'
}, {
    text: '辽',
    letter: 'L',
    province: '辽宁省'
}, {
    text: '鲁',
    letter: 'L',
    province: '山东省'
}, {
    text: '蒙',
    letter: 'M',
    province: '内蒙古自治区'
}, {
    text: '闽',
    letter: 'M',
    province: '福建省'
}, {
    text: '宁',
    letter: 'N',
    province: '宁夏回族自治区'
}, {
    text: '琼',
    letter: 'Q',
    province: '海南省'
}, {
    text: '青',
    letter: 'Q',
    province: '青海省'
}, {
    text: '苏',
    letter: 'S',
    province: '江苏省'
}, {
    text: '陕',
    letter: 'S',
    province: '陕西省'
}, {
    text: '台',
    letter: 'T',
    province: '台湾省'
}, {
    text: '皖',
    letter: 'W',
    province: '安徽省'
}, {
    text: '湘',
    letter: 'X',
    province: '湖南省'
}, {
    text: '新',
    letter: 'X',
    province: '新疆维吾尔自治区'
}, {
    text: '冀',
    letter: 'Y',
    province: '河北省'
}, {
    text: '豫',
    letter: 'Y',
    province: '河南省'
}, {
    text: '粤',
    letter: 'Y',
    province: '广东省'
}, {
    text: '渝',
    letter: 'Y',
    province: '重庆市'
}, {
    text: '云',
    letter: 'Y',
    province: '云南省'
}, {
    text: '浙',
    letter: 'Z',
    province: '浙江省'
}, {
    text: '藏',
    letter: 'Z',
    province: '西藏自治区'
}, {
    text: '临',
    letter: 'L',
    province: '临时车牌'
}]

export default provinceLetters